import PropTypes from 'prop-types';
import React from 'react';

import { Container } from './styles';

const LoadingContainer = ({ height = '30vh', children }) => (
  <Container height={height}>{children}</Container>
);

LoadingContainer.propTypes = {
  height: PropTypes.string,
  children: PropTypes.element.isRequired,
};

LoadingContainer.defaultProps = {
  height: '30vh',
};

export { LoadingContainer };
